import React, { useState } from "react";
import api, { formatApiError } from "../../api";
import { label } from "../../labels";
import { btnPrimary, inputCls, panel } from "./ui";

export default function GoalsAdmin({ studentId, goals, onChange }) {
  const [form, setForm] = useState({ title: "", description: "" });
  const [err, setErr] = useState("");
  const run = async (fn) => {
    try {
      await fn();
      setErr("");
      onChange();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };
  const submit = (e) => {
    e.preventDefault();
    run(async () => {
      await api.post("/goals", { studentId, title: form.title, description: form.description || null });
      setForm({ title: "", description: "" });
    });
  };
  return (
    <div className="space-y-4">
      <form onSubmit={submit} className={`${panel} grid sm:grid-cols-[1fr_2fr_auto] gap-3`} data-testid="eid-goal-form">
        <input required maxLength={120} className={inputCls} placeholder="Objetivo" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="eid-goal-title" />
        <input maxLength={500} className={inputCls} placeholder="Descripción (opcional)" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="eid-goal-desc" />
        <button className={btnPrimary} data-testid="eid-goal-submit">Agregar</button>
      </form>
      {err && <div className="text-[12px] text-[#9B2C3B]" data-testid="eid-goal-error">{err}</div>}
      <div className="space-y-2" data-testid="eid-goal-list">
        {goals.map((g) => (
          <div key={g.id} className="p-3 bg-white rounded-2xl border border-[#132C44]/10 flex items-start justify-between gap-3">
            <div>
              <div className="font-semibold text-[14px]">{g.title}</div>
              {g.description && <div className="text-[12px] text-[#132C44]/70">{g.description}</div>}
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <span className="text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5 rounded-full bg-[#8AA986]/20 text-[#4F6B47]">{label(g.status)}</span>
              {g.status === "active" && (
                <button onClick={() => run(() => api.patch(`/goals/${g.id}`, { status: "met" }))} className="text-[12px] font-semibold text-[#4F6B47] hover:underline" data-testid={`eid-goal-met-${g.id}`}>
                  Marcar alcanzado
                </button>
              )}
            </div>
          </div>
        ))}
        {!goals.length && <p className="text-[13px] text-[#132C44]/60">Sin objetivos.</p>}
      </div>
    </div>
  );
}
